<div class="acd">
  <div class="acd-header">
    <div class="acd-header-text">
      <p class="acd-eyebrow">Timesheet · Period</p>
      <h2 class="acd-heading">Absence insight</h2>
      <p class="acd-range">{{ data.rangeLabel }}</p>
      <p class="acd-hint">{{ hint }}</p>
    </div>
    <button type="button" class="acd-close" mat-dialog-close aria-label="Close dialog">
      <mat-icon fontSet="material-icons-outlined">close</mat-icon>
    </button>
  </div>

  <div class="acd-toolbar" *ngIf="absenceSummary && !loading">
    <div class="acd-stat">
      <span class="acd-stat-value">{{ absenceSummary.employees_with_absence || 0 }}</span>
      <span class="acd-stat-label">with absence</span>
    </div>
    <div class="acd-stat">
      <span class="acd-stat-value">{{ absenceSummary.total_absent_days || 0 }}</span>
      <span class="acd-stat-label">absence events</span>
    </div>
    <div class="acd-legend">
      <span class="acd-legend-item"><i class="acd-dot acd-dot--absent"></i>Absent</span>
      <span class="acd-legend-item"><i class="acd-dot acd-dot--extra"></i>Unscheduled activity</span>
      <span class="acd-legend-item"><i class="acd-dot acd-dot--ok"></i>All present</span>
      <span class="acd-legend-item"><i class="acd-dot acd-dot--off"></i>No scheduled work</span>
    </div>
  </div>

  <div class="acd-body">
    <div *ngIf="loading" class="acd-skeleton">
      <ngx-skeleton-loader count="3" [theme]="{ 'border-radius': '12px', height: '100px', width: '100%' }"></ngx-skeleton-loader>
    </div>

    <div *ngIf="!loading" class="acd-grid">
      <div
        class="acd-cell"
        *ngFor="let day of absenceDays"
        [class.acd-cell--muted]="isAbsenceNoScheduledWorkDay(day)"
        [class.acd-cell--has-absent]="day.absent_count > 0">
        <div class="acd-cell-head">
          <span class="acd-cell-date">{{ datePipe.transform(day.date, 'EEE d MMM') }}</span>
          <div class="acd-cell-badges">
            <span class="acd-badge acd-badge--absent" *ngIf="day.absent_count" title="Absent">{{ day.absent_count }}</span>
            <span class="acd-badge acd-badge--extra" *ngIf="offScheduleCount(day)" title="Unscheduled activity">{{ offScheduleCount(day) }}</span>
          </div>
        </div>

        <div class="acd-cell-block" *ngIf="day.absent_count > 0">
          <p class="acd-cell-label">Absent</p>
          <div
            class="acd-chips"
            [class.acd-chips--scroll]="isAbsenceDayExpanded(day) && (day.absent_employees || []).length > absencePreviewLimit">
            <button type="button" class="acd-chip acd-chip--absent" *ngFor="let emp of absenceEmployeesForDisplay(day)" (click)="selectAbsencePill(day, emp)">
              {{ emp.name }}
            </button>
            <button
              type="button"
              class="acd-chip acd-chip--more"
              *ngIf="absenceHiddenCount(day) > 0 && !isAbsenceDayExpanded(day)"
              (click)="toggleAbsenceDayExpand(day, $event)">
              +{{ absenceHiddenCount(day) }} more
            </button>
            <button
              type="button"
              class="acd-link"
              *ngIf="isAbsenceDayExpanded(day) && (day.absent_employees || []).length > absencePreviewLimit"
              (click)="toggleAbsenceDayExpand(day, $event)">
              Show less
            </button>
          </div>
        </div>

        <div class="acd-cell-block" *ngIf="offScheduleCount(day) > 0" [class.acd-cell-block--split]="day.absent_count > 0">
          <p class="acd-cell-label acd-cell-label--extra">Unscheduled activity</p>
          <div class="acd-chips">
            <button type="button" class="acd-chip acd-chip--extra" *ngFor="let row of (day.off_schedule_employees || [])" (click)="selectOffSchedulePill(day, row)">
              {{ row.name }}
            </button>
          </div>
        </div>

        <div class="acd-status" *ngIf="isAbsenceAllPresentDay(day)">
          <mat-icon fontSet="material-icons-outlined" class="acd-status-icon acd-status-icon--ok">check_circle</mat-icon>
          <span>All present</span>
        </div>
        <div class="acd-status" *ngIf="isAbsenceNoScheduledWorkDay(day)">
          <mat-icon fontSet="material-icons-outlined" class="acd-status-icon acd-status-icon--off">bedtime</mat-icon>
          <span>No scheduled work</span>
        </div>
      </div>
    </div>
  </div>

  <div class="acd-footer" *ngIf="selectedAbsenceDetail">
    <div class="acd-footer-text">
      <span class="acd-footer-name">{{ selectedAbsenceDetail.name }}</span>
      <span class="acd-footer-line">{{ datePipe.transform(selectedAbsenceDetail.date, 'dd MMM yyyy') }} · {{ selectedAbsenceDetail.reason || '—' }}</span>
      <span class="acd-footer-line">Shift · {{ selectedAbsenceDetail.shift_name || '—' }}</span>
    </div>
    <button type="button" class="acd-primary" (click)="openUserWiseFromDetail()">Open user-wise timesheet</button>
  </div>
</div>
